import type { AppRouteConfig } from '../types';
import { serviceBusinessPaths } from '@/feature/service-business/data/serviceBusinessConfig';
import {
  backofficeServiceBusinessChildren,
  tenantPublicServiceBusinessChildren
} from './hsdesk';

export const serviceBusinessTenantRoutes: AppRouteConfig[] = [
  {
    path: serviceBusinessPaths.tenantPublicBasePath,
    layout: 'EmptyLayout',
    children: tenantPublicServiceBusinessChildren
  },
  {
    path: '/login',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'SignInPage', index: true }]
  },
  {
    path: '/create-account',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'CreateAccountPage', index: true }]
  },
  {
    path: '/activate-account',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'ActivateAccountPage', index: true }]
  },
  {
    path: '/onboarding',
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [
      { path: null, element: 'CompanyOwnerOnboardingPage', index: true }
    ]
  },
  {
    path: '/set-password',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'SetPasswordPage', index: true }]
  },
  {
    path: `${serviceBusinessPaths.tenantBackofficeBasePath}/website/preview`,
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [
      {
        path: null,
        element: 'WebsiteBuilderPreviewEntryPage',
        index: true
      }
    ]
  },
  {
    path: `${serviceBusinessPaths.tenantBackofficeBasePath}/website/local-preview/:previewId`,
    layout: 'EmptyLayout',
    children: [
      {
        path: null,
        element: 'WebsiteBuilderPreviewPage',
        index: true
      }
    ]
  },
  {
    path: `${serviceBusinessPaths.tenantBackofficeBasePath}/website/pages/:pageId/preview`,
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [
      {
        path: null,
        element: 'WebsiteBuilderPreviewPage',
        index: true
      }
    ]
  },
  {
    path: serviceBusinessPaths.tenantBackofficeBasePath,
    layout: 'MainLayout',
    element: 'ProtectedRoute',
    children: backofficeServiceBusinessChildren
  },
  {
    path: `${serviceBusinessPaths.tenantBackofficeBasePath}/website-preview`,
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [
      {
        path: null,
        element: 'WebsiteBuilderPreviewEntryPage',
        index: true
      }
    ]
  },
  {
    path: '/client',
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [{ path: null, element: 'CustomerPortalPage', index: true }]
  },
  {
    path: '/customer',
    layout: 'EmptyLayout',
    element: 'ProtectedRoute',
    children: [{ path: null, element: 'CustomerPortalPage', index: true }]
  },
  {
    path: '/order-status/:token',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'PublicOrderViewPage', index: true }]
  },
  {
    path: '/order/:orderId',
    layout: 'EmptyLayout',
    children: [{ path: null, element: 'PublicOrderViewPage', index: true }]
  }
];
